module.exports = __webpack_public_path__ + "static/media/AO.8d934cbc.svg";